import axios from "axios";
import { BASE_URL } from "../../../variables";
import { sessionExpireTimeout } from "@redux/actions/utility-actions";
import { getMyDiaryDealerDetails, getMyDiaryWSSDetails } from "@redux/actions/mydiaryDetails-actions";

export const addMyDiaryApi =
  ({RecordtypeName, Title, Observation, fileExtension, fileName, base64, wssCode, dealerCode }) =>
  async (dispatch) => {
    const options = {
      url: `${BASE_URL}/services/apexrest/MyDiary/`,
      method: "post",
      data: { Title, Observation, fileExtension, fileName, base64, wssCode, dealerCode },
    };
    try {
      const response = await axios(options);
      if (response.status === 200) {
        if (RecordtypeName === "Visit Plan") {
          dispatch(getMyDiaryDealerDetails(dealerCode));
        } else {
          dispatch(getMyDiaryWSSDetails(wssCode));
        }
        return {
          success: true,
          data: response?.data,
        };
      } else {
        throw Error("Something Went Wrong..!!");
      }
    } catch (err) {
      if (err.code === "ERR_NETWORK") {
        sessionExpireTimeout(dispatch);
      } else {
        return {
          success: false,
          msg: "Somthing Went Wrong..!!",
        };
      }
    }
  };
